import { render } from "./CreateListGroupModal.vue?vue&type=template&id=5e258e17"
import script from "./CreateListGroupModal.vue?vue&type=script&lang=js"
export * from "./CreateListGroupModal.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/vhosts/gilcode.com/kwordz.gilcode.com/packages/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__